// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `\$font-weight: 400;
\$background-color: #fff;
\$border-color: #efefef;
\$text-color: #333;
\$handle-color: rgba(0, 0, 0, 0.25);
\$box-shadow-border: 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05);
\$box-shadow-common: 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);
\$box-shadow: \$box-shadow-border, \$box-shadow-common;
\$focused-outline-color: #4c9ffe;

@keyframes Item_pop__LAnki {
  0% {
    transform: scale(1);
    box-shadow: var(--box-shadow);
  }
  100% {
    transform: scale(var(--scale));
    box-shadow: var(--box-shadow-picked-up);
  }
}

@keyframes Item_fadeIn__8PtdF {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.Item_Wrapper__KUpU2 {
  display: flex;
  box-sizing: border-box;
  transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)
    scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1));
  transform-origin: 0 0;
  touch-action: manipulation;

  &.Item_fadeIn__8PtdF {
    animation: Item_fadeIn__8PtdF 500ms ease;
  }

  &.Item_dragOverlay__LV5Zq {
    --scale: 1.05;
    --box-shadow: \$box-shadow;
    --box-shadow-picked-up: \$box-shadow-border,
      -1px 0 15px 0 rgba(34, 33, 81, 0.01),
      0px 15px 15px 0 rgba(34, 33, 81, 0.25);
    z-index: 999;
  }
}

.Item_Item__C8bBI {
  position: relative;
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: 18px 20px;
  background-color: \$background-color;
  box-shadow: \$box-shadow;
  outline: none;
  border-radius: calc(4px / var(--scale-x, 1));
  box-sizing: border-box;
  list-style: none;
  transform-origin: 50% 50%;

  -webkit-tap-highlight-color: transparent;

  color: \$text-color;
  font-weight: \$font-weight;
  font-size: 1rem;
  white-space: nowrap;

  transform: scale(var(--scale, 1));
  transition: box-shadow 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);

  &:focus-visible {
    box-shadow: 0 0px 4px 1px \$focused-outline-color, \$box-shadow;
  }

  &:not(.Item_withHandle__sT6OL) {
    touch-action: manipulation;
    cursor: grab;
  }

  &.Item_dragging__uBy07:not(.Item_dragOverlay__LV5Zq) {
    opacity: var(--dragging-opacity, 0.5);
    z-index: 0;

    &:focus {
      box-shadow: \$box-shadow;
    }
  }

  &.Item_disabled__TGYB\\+ {
    color: #999;
    background-color: #f1f1f1;
    &:focus {
      box-shadow: 0 0px 4px 1px rgba(0, 0, 0, 0.1), \$box-shadow;
    }
    cursor: not-allowed;
  }

  &.Item_dragOverlay__LV5Zq {
    cursor: inherit;
    /* box-shadow: 0 0px 6px 2px \$focused-outline-color; */
    animation: Item_pop__LAnki 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);
    transform: scale(var(--scale));
    box-shadow: var(--box-shadow-picked-up);
    opacity: 1;
  }

  &.Item_color__5paxP:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: 100%;
    width: 3px;
    display: block;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background-color: var(--color);
  }

  &:hover {
    .Item_Remove__IF-Wv {
      visibility: visible;
    }
  }
}

.Item_Remove__IF-Wv {
  visibility: hidden;
}

.Item_Actions__uaQKX {
  display: flex;
  align-self: flex-start;
  margin-top: -12px;
  margin-left: auto;
  margin-bottom: -15px;
  margin-right: -10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Item/Item.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,uBAAuB;AACvB,sBAAsB;AACtB,iBAAiB;AACjB,kCAAkC;AAClC,8EAA8E;AAC9E,gFAAgF;AAChF,mDAAmD;AACnD,+BAA+B;;AAE/B;EACE;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;uDACqD;EACrD,qBAAqB;EACrB,0BAA0B;;EAE1B;IACE,wCAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB;;4CAEwC;IACxC,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,uBAAuB;EACvB,aAAa;EACb,4CAA4C;EAC5C,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;;EAEzB,wCAAwC;;EAExC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;;EAEnB,iCAAiC;EACjC,gEAAgE;;EAEhE;IACE,6DAA6D;EAC/D;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,UAAU;;IAEV;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB;MACE,yDAAyD;IAC3D;IACA,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,sDAAsD;IACtD,oEAAwD;IACxD,8BAA8B;IAC9B,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,OAAO;IACP,YAAY;IACZ,UAAU;IACV,cAAc;IACd,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":["$font-weight: 400;\n$background-color: #fff;\n$border-color: #efefef;\n$text-color: #333;\n$handle-color: rgba(0, 0, 0, 0.25);\n$box-shadow-border: 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05);\n$box-shadow-common: 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);\n$box-shadow: $box-shadow-border, $box-shadow-common;\n$focused-outline-color: #4c9ffe;\n\n@keyframes pop {\n  0% {\n    transform: scale(1);\n    box-shadow: var(--box-shadow);\n  }\n  100% {\n    transform: scale(var(--scale));\n    box-shadow: var(--box-shadow-picked-up);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.Wrapper {\n  display: flex;\n  box-sizing: border-box;\n  transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)\n    scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1));\n  transform-origin: 0 0;\n  touch-action: manipulation;\n\n  &.fadeIn {\n    animation: fadeIn 500ms ease;\n  }\n\n  &.dragOverlay {\n    --scale: 1.05;\n    --box-shadow: $box-shadow;\n    --box-shadow-picked-up: $box-shadow-border,\n      -1px 0 15px 0 rgba(34, 33, 81, 0.01),\n      0px 15px 15px 0 rgba(34, 33, 81, 0.25);\n    z-index: 999;\n  }\n}\n\n.Item {\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  padding: 18px 20px;\n  background-color: $background-color;\n  box-shadow: $box-shadow;\n  outline: none;\n  border-radius: calc(4px / var(--scale-x, 1));\n  box-sizing: border-box;\n  list-style: none;\n  transform-origin: 50% 50%;\n\n  -webkit-tap-highlight-color: transparent;\n\n  color: $text-color;\n  font-weight: $font-weight;\n  font-size: 1rem;\n  white-space: nowrap;\n\n  transform: scale(var(--scale, 1));\n  transition: box-shadow 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);\n\n  &:focus-visible {\n    box-shadow: 0 0px 4px 1px $focused-outline-color, $box-shadow;\n  }\n\n  &:not(.withHandle) {\n    touch-action: manipulation;\n    cursor: grab;\n  }\n\n  &.dragging:not(.dragOverlay) {\n    opacity: var(--dragging-opacity, 0.5);\n    z-index: 0;\n\n    &:focus {\n      box-shadow: $box-shadow;\n    }\n  }\n\n  &.disabled {\n    color: #999;\n    background-color: #f1f1f1;\n    &:focus {\n      box-shadow: 0 0px 4px 1px rgba(0, 0, 0, 0.1), $box-shadow;\n    }\n    cursor: not-allowed;\n  }\n\n  &.dragOverlay {\n    cursor: inherit;\n    /* box-shadow: 0 0px 6px 2px $focused-outline-color; */\n    animation: pop 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);\n    transform: scale(var(--scale));\n    box-shadow: var(--box-shadow-picked-up);\n    opacity: 1;\n  }\n\n  &.color:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    height: 100%;\n    width: 3px;\n    display: block;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n    background-color: var(--color);\n  }\n\n  &:hover {\n    .Remove {\n      visibility: visible;\n    }\n  }\n}\n\n.Remove {\n  visibility: hidden;\n}\n\n.Actions {\n  display: flex;\n  align-self: flex-start;\n  margin-top: -12px;\n  margin-left: auto;\n  margin-bottom: -15px;\n  margin-right: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": `Item_Wrapper__KUpU2`,
	"fadeIn": `Item_fadeIn__8PtdF`,
	"dragOverlay": `Item_dragOverlay__LV5Zq`,
	"Item": `Item_Item__C8bBI`,
	"pop": `Item_pop__LAnki`,
	"withHandle": `Item_withHandle__sT6OL`,
	"dragging": `Item_dragging__uBy07`,
	"disabled": `Item_disabled__TGYB+`,
	"color": `Item_color__5paxP`,
	"Remove": `Item_Remove__IF-Wv`,
	"Actions": `Item_Actions__uaQKX`
};
export default ___CSS_LOADER_EXPORT___;
